import React from 'react';
import { Route, Switch } from 'react-router';

import { Checkout } from '@root/components/checkout/checkout';
import { BlogNotFound } from '@root/components/errors/blog_not_found';
import { NotFound } from '@root/components/errors/not_found';

// Should be used instead of React Router's plain `Switch` so
// we can have a consistent collection of shared routes
export const SwitchWithSharedRoutes: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Switch>
    {children}
    <Route path="/book/:service" component={Checkout} />
    <Route path="/blog" exact component={BlogNotFound} />
    <Route path="/blog/*" component={BlogNotFound} />
    <Route component={NotFound} />
  </Switch>
);
